import axios from "axios";

export function isBackendUnavailableError(error: unknown): boolean {
  return axios.isAxiosError(error) && (!error.response || error.response.status >= 500);
}
